import React from 'react'

// `className` replaces the default box styling, for callers that frame the
// input themselves (the Requests date range). `openOnClick` opens the
// browser's calendar from anywhere on the input, for callers that hide the
// native calendar icon.
export default function DatePicker({ value, onChange, min, max, placeholder, ariaLabel, className, openOnClick = false }) {
  return (
    <input
      type="date"
      value={value || ''}
      min={min}
      max={max}
      placeholder={placeholder}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.value)}
      data-empty={!value || undefined}
      onClick={openOnClick ? (e) => { try { e.currentTarget.showPicker?.() } catch { /* not allowed here; typing still works */ } } : undefined}
      className={className || "h-9 px-3 border border-gray-200 dark:border-gray-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-500/30 focus:border-navy-500 dark:bg-gray-800 dark:text-gray-200 bg-white transition-colors"}
    />
  )
}
